module.exports = __webpack_public_path__ + "static/img/about_2.859a238.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_2.jpg
// module id = seMi
// module chunks = 1